<template>
    <v-dialog v-model="$store.state.customerRate.add" min-width="1360px">
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Rates Updates by {{ customer }}</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.customerRate.add = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    :headers="headers"
                    :items="excel"
                    height="600px"
                    dense
                    disable-pagination
                    hide-default-footer
                >
                </v-data-table>
                <v-row justify="end">
                    <v-col cols="1">
                        <v-btn color="primary" @click="uploadRates"
                            >Save Rates</v-btn
                        >
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    props: ['data', 'customer', 'stations', 'terminals'],
    data: function() {
        return {
            excel: [],
            headers: [
                { text: 'Terminal', value: 'TerminalName', width: '20%' },
                { text: 'Station', value: 'StationName', width: '20%' },
                { text: 'ShipTo', value: 'ShipTo' },
                { text: 'GasOldRate', value: 'GasOldRate' },
                { text: 'DiesOldRate', value: 'DiesOldRate' },
                { text: 'GasNewRate', value: 'GasNewRate' },
                { text: 'DiesNewRate', value: 'DiesNewRate' },
                { text: 'EffectiveFrom', value: 'EffectiveFrom' },
                { text: 'EffectiveTo', value: 'EffectiveTo' },
                { text: 'ShiptoName', value: 'ShiptoName', width: '20%' }
            ]
        };
    },
    async mounted() {
        this.relStationTerminal();
    },

    methods: {
        relStationTerminal: async function() {
            const exl = this.data;
            exl.forEach(rate => {
                const st = this.stations.findIndex(x => {
                    return rate.Station == x['id'];
                });
                const ter = this.terminals.findIndex(x => {
                    return rate.Terminal == x.id;
                });
                rate.StationName = this.stations[st]['Name'];
                rate.TerminalName = this.terminals[ter]['Name'];
            });

            this.excel = exl;
            console.log(this.excel, exl);
        },

        uploadRates: function() {
            var str = this.$store;
            var parms = {
                data: this.data
            };
            axios
                .post('customer-rate/upload', parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved successes'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 409) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This range of dates per customer already exists.'
                        });
                    }
                });
        },
        convertToExcelDate: function(excelDate) {
            // Fecha de referencia de Excel (1 de enero de 1900).
            var excelReferenceDate = moment('1900-01-01', 'YYYY-MM-DD');

            // Agregar los días al inicio de Excel hasta llegar a la fecha deseada.
            var date = excelReferenceDate.add(excelDate, 'days');

            // Obtener la fecha en el formato deseado (YYYY-MM-DD).
            var formattedDate = date.format('YYYY-MM-DD');

            return formattedDate;
        }
    }
};
</script>
